import React, {useState} from 'react'
import SelectType from '../SelectType.json'

const Select = ({handleChange, name, reason}) => {

    const [dropdown, setdropdown] = useState(false)

    return(
        <div className="form select">
            <div className="hidden_input">
                {
                    SelectType.fields
                        .map(i =>
                            <input value={i.id} onClick={handleChange} key={i.id} type='radio' name={name} readOnly={i.id} id={i.id} />
                        )
                }
            </div>
            <div className="list">
                <p dropdown={dropdown.toString()} onClick={() => setdropdown(!dropdown)} >{reason ? reason : SelectType.content} <ion-icon name="caret-down-outline"></ion-icon></p>
                <ul dropdown={dropdown.toString()}>
                    {
                        SelectType.fields
                            .map( i =>
                                <li onClick={() => setdropdown(false)} key={i.id}>
                                    <label htmlFor={i.id}>{i.content}</label>
                                </li>
                            )
                    }
                </ul>
            </div>
        </div>
    )
}

export default Select